import { useEffect, useRef, useState } from "react";
import { marked } from "marked";

import howto from "../docs/howto.md?raw";

export default function DocsPage() {
  const [html, setHtml] = useState<string>("");
  const articleRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const result = marked.parse(howto, { async: false, gfm: true, breaks: false });
    setHtml(typeof result === "string" ? result : "");
  }, []);

  useEffect(() => {
    if (!articleRef.current || !html) return;
    const pres = articleRef.current.querySelectorAll<HTMLPreElement>("pre");
    pres.forEach(pre => {
      if (pre.querySelector(".copy-btn")) return;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "copy-btn";
      btn.textContent = "Copy";
      btn.addEventListener("click", async () => {
        const code = pre.querySelector("code");
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code.textContent ?? "");
          btn.textContent = "Copied";
          setTimeout(() => { btn.textContent = "Copy"; }, 1500);
        } catch {
          btn.textContent = "Failed";
          setTimeout(() => { btn.textContent = "Copy"; }, 1500);
        }
      });
      pre.appendChild(btn);
    });
  }, [html]);

  return (
    <article
      ref={articleRef}
      className="howto max-w-3xl"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
